import api from './config';

export interface BrandAssignment {
  id?: number;
  brand_id: string;
  brand_name: string;
  manager_name: string;
  position_type: string;
  job_title: string;
  outlet_id: string;
  user_id?: string;
  email?: string;
}

export interface AdminUser {
  id: number;
  email: string;
  is_admin: boolean;
  created_at: string;
  updated_at: string;
  brand_assignments: BrandAssignment[];
}

export interface CreateUserRequest {
  email: string;
  password: string;
  is_admin?: boolean;
  brand_assignments: Omit<BrandAssignment, 'id' | 'user_id' | 'email'>[];
}

export interface UpdateUserRequest {
  email?: string;
  password?: string;
  is_admin?: boolean;
  brand_assignments?: Omit<BrandAssignment, 'id' | 'user_id' | 'email'>[];
}

export interface AdminBrand {
  brand_id: string;
  brand_name: string;
}

interface PaginatedResponse<T> {
  success: boolean;
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const userManagementService = {
  async getUsers(params: {
    page?: number;
    limit?: number;
    search?: string;
    brand_id?: string;
    position_type?: string;
  } = {}): Promise<PaginatedResponse<AdminUser>> {
    const response = await api.get('/admin/users', { params });
    return response.data;
  },

  async getUserById(id: number): Promise<{ success: boolean; data: AdminUser }> {
    const response = await api.get(`/admin/users/${id}`);
    return response.data;
  },

  async createUser(data: CreateUserRequest): Promise<{ success: boolean; data: AdminUser }> {
    const response = await api.post('/admin/users', data);
    return response.data;
  },

  async updateUser(id: number, data: UpdateUserRequest): Promise<{ success: boolean; data: AdminUser }> {
    const response = await api.put(`/admin/users/${id}`, data);
    return response.data;
  },

  async deleteUser(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/admin/users/${id}`);
    return response.data;
  },

  async getBrands(): Promise<{ success: boolean; data: AdminBrand[] }> {
    const response = await api.get('/admin/brands');
    return response.data;
  },
};
